import {SignDocumentStep} from '../types/SignDocumentStep';

export const isErrorStep = (
  signDocumentStep: SignDocumentStep
): signDocumentStep is `${'Remote' | 'OnSite'}_error` => signDocumentStep.endsWith('_error');
